// extracted by mini-css-extract-plugin
module.exports = {"card":"style-module__card___1qPfJ","wideCard":"style-module__wideCard___9ZBIn","score":"style-module__score___1OBtf","sectionName":"style-module__sectionName___V86MU"};